export default {
  data () {
    return {
      userContactDetails: {
        form: {
          email: {
            type: 'input',
            name: 'email',
            label: 'Email',
            placeholder: 'Enter email',
            value: '',
            class: 'col-12 pr-12px',
            validation: [{ name: 'email', params: () => this.userContactDetails.form.email.value }, { name: 'requiredIf', params: () => !!this.userContactDetails.form.email.value }]
          },
          mobile: {
            type: 'input',
            name: 'mobile',
            label: 'Mobile',
            placeholder: 'Mobile',
            validation: [],
            value: null,
            class: 'col-6 pr-12px'
          },
          skype: {
            type: 'input',
            name: 'skype',
            label: 'Skype',
            placeholder: 'Skype',
            validation: [],
            value: null,
            class: 'col-6 pr-12px'
          },
          telegram: {
            type: 'input',
            name: 'telegram',
            label: 'Telegram',
            placeholder: 'Telegram',
            validation: [],
            value: null,
            class: 'col-6 pr-12px'
          },
          other: {
            type: 'input',
            name: 'other',
            label: 'Other contact',
            placeholder: 'Other contact',
            validation: [],
            value: null,
            class: 'col-6 pr-12px'
          }
        }
      }
    }
  },
  methods: {
    fillContactDetailsData (data) {
      this.userContactDetails.form.email.value = data.email || ''
      this.userContactDetails.form.mobile.value = data.mobile || null
      this.userContactDetails.form.telegram.value = data.telegram || null
      this.userContactDetails.form.skype.value = data.skype || null
      this.userContactDetails.form.other.value = data.other || null
    },
    hideContactDetailsEmailField () {
      this.userContactDetails.form.email.hidden = true
    },
    updateValidationRules (data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        this.userContactDetails.form[element.key].validation = element.validation
        this.userContactDetails.form[element.key].label += ' *'
      }
    }
  }
}
